<template>
  <div class="main">
    <div class="handle-search">
      <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="showDialog()">新增</el-button>
      <div class="search-box">
        <div class="searchItem">
          <span class="tit">状态：</span>
           <el-select style="width:120px" size="small" v-model="query.filterStatus" clearable @change="getAllAdvertisementList">
              <el-option value="1" label="启用"></el-option>
              <el-option value="0" label="停用"></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span class="tit">广告账号：</span>
          <el-input
            style="width:160px"
            size="small"
            v-model="query.searchText"
            placeholder="请输入广告账号"
          ></el-input>
        </div>
        <div class="searchItem">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="getAllAdvertisementList"
          >搜索</el-button>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
      :height="tableHeight"
      ref="multipleTable"
      @row-click="showDialog"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    >
      <el-table-column label="序号" width="100" align="center" type="index"></el-table-column>
      <el-table-column prop="advertisementAccount" label="广告账号" align="center">
        <template slot-scope="scope">
          <span @click.stop>{{scope.row.advertisementAccount}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="advertisementId" label="广告账号ID" align="center">
        <template slot-scope="scope">
          <span @click.stop>{{scope.row.advertisementId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="域名" align="center">
        <template slot-scope="scope">
          <p v-for="(item, index) in scope.row.domainList" :key="index">{{item}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="余额[$]" align="center"></el-table-column>
      <el-table-column label="使用人" align="center">
        <template slot-scope="scope">
          <p v-for="(item, index) in scope.row.userInfos" :key="index">{{item.userNickName}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="a" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status==1?true:false"
            active-color="#ff4700"
            @change="updateState(scope.row)"
            @click.stop.native
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <div>
            <el-button
              type="primary"
              icon="el-icon-attract"
              size="small"
              @click.stop="goPay(scope.row)"
            >充值</el-button>
            <el-button
              type="primary"
              icon="el-icon-document"
              size="small"
              @click.stop="goDetail(scope.row)"
            >明细</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
        :page-sizes="[ 20,50,100,200]"
        @size-change="sizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 新增 -->
    <el-dialog :title="dialogTitile" :visible.sync="dialogFormVisible" width="650px">
      <div class="content">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="广告账号:">
            <el-input style="width:60%" v-model="form.advertisementAccount" placeholder="请输入广告账号"></el-input>
          </el-form-item>
          <el-form-item label="广告账号ID:">
            <el-input style="width:60%" v-model="form.advertisementId" placeholder="请输入广告账号ID"></el-input>
          </el-form-item>
          <el-form-item label="类型:">
            <el-select
              v-model="form.advertisementAccountType"
              style="width:293px"
              placeholder="请选择类型"
            >
              <el-option
                v-for="(item, index) in advTypeArr"
                :key="index"
                :label="item.typeInfo"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="域名：">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入域名,一行一个"
              v-model="domain"
              style="width:60%"
            ></el-input>
          </el-form-item>
          <el-form-item label="主页：">
            <el-input placeholder="请输入主页" style="width:60%" v-model="form.mainIndex"></el-input>
          </el-form-item>
          <el-form-item label="开户渠道：">
            <el-input placeholder="请输入开户渠道" style="width:60%" v-model="form.accountOpeningChannel"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  AddOrUpdateAdvertisementAccount,
  UpdateAdvertisementAccountStatus,
  DepositToAccount,
  GetAllAdvertisementList,
  GetAdvertisementTypeDropList,
  GetAllAdvertisementListDropList
} from "@/utils/api";
export default {
  data() {
    return {
      tableHeight: "",
      dialogFormVisible: false,
      bindShop: false,
      bindRole: false,
      domain: "",
      advTypeArr: [],
      dialogTitile: "新增广告账号",
      tableData: [],
      roleList: [],
      shopList: [],
      pageTotal: 10,
      UserId: 0,
      query: {
        pageStart: 1,
        limit: 20,
        searchText: "",
        filterStatus:"1"
      },
      form: {
        id: -1,
        accountOpeningChannel: "",
        mainIndex: "",
        advertisementAccount: "",
        advertisementId: "",
        advertisementAccountType: ""
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 160;
    });
  },
  methods: {
    showDialog(item) {
      if (!item) {
        this.dialogTitile = "新增广告账号";
        this.form = {
          id: -1
        };
      } else {
        let data = JSON.parse(JSON.stringify(item));
        this.dialogTitile = "修改广告账号";
        this.form = data;
        if (data.domainList.length > 0) {
          this.domain = data.domainList.join("\n");
        }
      }
      this.dialogFormVisible = true;
    },
    goPay(item) {
      this.$prompt("请输入充值金额（元）", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^(-)?\d+(\.\d+)?$/,
        inputErrorMessage: "输入的格式不正确"
      })
        .then(({ value }) => {
          DepositToAccount({
            id: item.id,
            Amount: Number(value)
          }).then(res => {
            if (res) {
              this.$message.success("充值成功");
              this.getAllAdvertisementList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消充值"
          });
        });
    },
    goDetail(item) {
      this.$router.push({
        path: "/advNumberDetail",
        query: {
          advertisementAccountId: item.id
        }
      });
    },
    updateState(item) {
      UpdateAdvertisementAccountStatus({
        Id: item.id,
        Status: item.status == 1 ? 0 : 1
      }).then(res => {
        if (res) {
          this.getAllAdvertisementList();
          this.$message.success("状态更新成功");
        }
      });
    },
    // 获取用户列表
    getAllAdvertisementList() {
      GetAllAdvertisementList(this.query).then(res => {
        if (res) {
          this.tableData = res.data;
          this.pageTotal = res.totalData;
        }
      });
    },
    getAdvertisementTypeDropList() {
      GetAdvertisementTypeDropList().then(res => {
        if (res) {
          this.advTypeArr = res;
        }
      });
    },
    //提交
    submit() {
      let lines = this.domain.split(/\n/);
      let {
        advertisementAccount,
        advertisementId,
        id,
        mainIndex,
        accountOpeningChannel,
        advertisementAccountType
      } = this.form;
      if (!advertisementAccount || !advertisementId || this.domain == "") {
        this.$message.error("广告账号、广告账户、域名都不能为空");
        return;
      }
      let domainList = lines.filter(item => item != "");

      AddOrUpdateAdvertisementAccount({
        advertisementAccount,
        advertisementId,
        advertisementAccountType,
        accountOpeningChannel,
        mainIndex,
        id,
        domainList
      }).then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.getAllAdvertisementList();
          this.dialogFormVisible = false;
        }
      });
    },
    // 改变分页
    handlePageChange(val) {
      this.query.pageStart = val;
      this.getAllAdvertisementList();
    },
    sizeChange(val) {
      this.query.limit = val;
      this.getAllAdvertisementList();
    }
  },
  components: {},
  created() {
    this.getAllAdvertisementList();
    this.getAdvertisementTypeDropList();
  }
};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 10px 0;
  .handle-search {
    background: #f3f3f3;
    border: 1px solid #ddd;
    margin-bottom: 10px;
    padding: 10px 20px;
    border-radius: 5px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .search-box {
      display: flex;
      width: 80%;
      justify-content: flex-end;
      .searchItem {
        margin-left: 20px;
        input,
        select {
          width: 160px;
        }
      }
    }
  }
  .pagination {
    text-align: center;
    margin-top: 20px;
  }
  .handle-fun {
    margin: 20px 0;
  }
  .shopList {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    padding-left: 60px;
    /deep/ .el-checkbox {
      margin-top: 5px;
      margin-bottom: 5px;
      width: 220px;
    }
  }
}
/deep/ .el-table__row {
  cursor: pointer;
}
</style>